"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
  name: 'couponEAct',
  components: {},
  props: {
    refresh: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler(newId, oldId) {
        console.log('refresh', newId, oldId);
        // 避免初始化时的不必要调用
        if (newId == oldId && oldId !== undefined) return;
        console.log('refresh', newId);
        if (newId) {
          this.fetchList();
        }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'reviewList'],
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      times: [],
      searchForm: {
        startTime: '',
        endTime: '',
        taskName: '',
        taskType: '',
        status: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      // ...新增二维码相关状态...
      typeOptions: []
    };
  }
}, "watch", {
  refresh: {
    immediate: true,
    handler: function handler(newId, oldId) {
      // 避免初始化时的不必要调用
      if (newId === oldId && oldId !== undefined) return;
      console.log('actId', newId);
      if (newId) {
        this.fetchList();
      }
    }
  }
}), "computed", {
  maxHeight: function maxHeight() {
    return "".concat(window.innerHeight - 497, "px");
  }
}), "methods", {
  getTaskType: function getTaskType() {
    var _this = this;
    var data = {
      page: 1,
      limit: 999
    };
    _redbook.default.getTaskType(data).then(function (res) {
      if (res.code == 200) {
        _this.typeOptions = res.records;
      }
    });
  },
  changeStatus: function changeStatus(id, status) {
    var _this2 = this;
    console.log('改变状态', id, status);
    _redbook.default.changeTaskStatus({
      id: id,
      status: status
    }).then(function (res) {
      _this2.$message.success('状态修改成功');
      _this2.fetchList();
    }).catch(function (err) {
      _this2.$message.error('状态修改失败');
    });
  },
  changeTaskSort: function changeTaskSort(row, value) {
    var _this3 = this;
    var oldSort = row.taskSort;
    // 立即更新界面体验
    row.taskSort = value;
    _redbook.default.changeTaskSort({
      id: row.id,
      taskSort: value
    }).then(function (res) {
      _this3.$message.success('排序更新成功');
      _this3.fetchList();
      // 可选择局部刷新或不刷新列表，这里只更新当前行
    }).catch(function (err) {
      // 回滚到旧值
      row.taskSort = oldSort;
      _this3.$message.error('排序更新失败');
    });
  },
  addAct: function addAct() {
    this.$emit('addAct');
  },
  postList: function postList(row) {
    this.$emit('postList', row);
  },
  handleEdit: function handleEdit(row) {
    this.$emit('handleEdit', row);
  },
  handleCopy: function handleCopy(row) {
    this.$emit('handleCopy', row);
  },
  reviewList: function reviewList(row) {
    this.$emit('reviewList', row);
  },
  changeTime: function changeTime(e) {
    console.log(e);
    if (!e || e.length === 0) {
      // 清除筛选条件
      this.searchForm.startTime = '';
      this.searchForm.endTime = '';
      this.fetchList(); // 重新加载数据
    } else {
      this.searchForm.startTime = e[0];
      this.searchForm.endTime = e[1];
    }
  },
  pad: function pad(n) {
    return n.toString().padStart(2, '0');
  },
  fetchList: function fetchList() {
    var _this4 = this;
    this.loading = true;
    _redbook.default.xyXhsTask(this.searchForm).then(function (res) {
      res.records.forEach(function (item) {
        var date = new Date(item.startTime);
        var date2 = new Date(item.endTime);
        var year = date.getFullYear();
        var month = _this4.pad(date.getMonth() + 1);
        var day = _this4.pad(date.getDate());
        var hours = _this4.pad(date.getHours());
        var mins = _this4.pad(date.getMinutes());
        var secs = _this4.pad(date.getSeconds());
        item.startTime = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
        var year2 = date2.getFullYear();
        var month2 = _this4.pad(date2.getMonth() + 1);
        var day2 = _this4.pad(date2.getDate());
        var hours2 = _this4.pad(date2.getHours());
        var mins2 = _this4.pad(date2.getMinutes());
        var secs2 = _this4.pad(date2.getSeconds());
        item.endTime = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
      });
      _this4.tableData = res.records || [];
      _this4.searchForm.total = res.total || 0;
    }).finally(function () {
      _this4.loading = false;
    });
  },
  // 每页条数变化
  handleSizeChange: function handleSizeChange(newSize) {
    this.searchForm.limit = newSize;
    this.searchForm.page = 1;
    this.fetchList();
  },
  // 页码变化
  handlePageChange: function handlePageChange(newPage) {
    this.searchForm.page = newPage;
    this.fetchList();
  }
}), "mounted", function mounted() {
  this.getTaskType();
  this.fetchList();
});